












































































































































































import Vue from 'vue'
import Component from 'vue-class-component'
import { IProduct, IVersion, IDeleteVersionRequest, IPatch, IReleasePatchRequest, IPatchIdRequest } from '../model/ProductsState'
import { IEnvironment } from '../model/Environment'
import EnvironmentService from '../services/EnvironmentService'
import { Watch } from 'vue-property-decorator'
import ProductService from '../services/ProductsService'
import PatchService from '../services/PatchService'
import ReleasePatchDialog from './ReleasePatchDialog.vue'

@Component({})
export default class Product extends Vue {
    product: IProduct
    productService: ProductService
    patchService: PatchService
    environmentService: EnvironmentService
    deleteVersionDialog = false;
    releasePatchDialog = false;
    deletePatchDialog = false;
    environments: IEnvironment[];
    selectedRelease = []

    patchToBeReleasedData: IReleasePatchRequest;

    constructor () {
      super()
      this.environments = []
      this.patchToBeReleasedData = {patchId: -1, environmentIds: []}
      this.productService = new ProductService();
      this.patchService = new PatchService();
      this.environmentService = new EnvironmentService();
      this.product = { id:-1, userId:-1, name: "placeholder", description: "placeholder", releaseDate: new Date(), versions: [] as IVersion[] }
    }

    editProduct(){
      this.$router.push({name: 'EditProduct', params:{productId: ""+this.product.id}})
    }

    newVersion(){
      this.$router.push({name: 'AddVersion', params: { productId: ""+this.product.id}})
    }

    editVersion(versionId: number){
      this.$router.push({name: 'EditVersion', params: { productId: ""+this.product.id, versionId: ""+ versionId}})
    }

    deleteVersion(version: IVersion){
      this.deleteVersionDialog = false;
      const versionDeleteRequest: IDeleteVersionRequest = {id: version.id}
      this.productService.deleteVersion(versionDeleteRequest).then(() => {
        this.productService.getProductById(this.product.id).then(prod => {
          this.product = prod
        })
      })
    }

    newPatch(versionId: number){
      this.$router.push({name: 'AddPatch', params: {
        productId: ""+this.product.id,
        versionId: ""+versionId
      }})
    }

    openReleasePatchDialog(patch: IPatch){
      
      this.patchToBeReleasedData.patchId = patch.id;
      this.patchToBeReleasedData.environmentIds = patch.releasedEnvironments;
      this.environmentService.getAllEnvironments().then(data => {
        this.environments = data
        this.releasePatchDialog = true;
      })
    }

    openDeletePatchDialog(patch: IPatch){
      this.deletePatchDialog = true;
    }

    deletePatch(patch: IPatch){
      const request: IPatchIdRequest = {patchId: patch.id}
      this.patchService.deletePatch(request).then(() => {
        this.closeAllPatchDialogs()
        this.changeProduct()
      })
    }

    releasePatch(){
      this.patchService.releasePatch(this.patchToBeReleasedData).then(() => {
          this.closeAllPatchDialogs()
          this.changeProduct()
      })
    }

    closeAllPatchDialogs(){
      this.releasePatchDialog = false;
      this.patchToBeReleasedData.patchId = -1;
      this.patchToBeReleasedData.environmentIds = [];

      this.deletePatchDialog = false
    }

    getColorForPatch(patch: IPatch){
      
      if(patch.releasedEnvironments.length > 0){
        return "green";
      }
      return "warning"
    }
    
    @Watch('$route.params', {immediate: true, deep: true})
    changeProduct(){
      this.productService.getProductById(+this.$route.params.id).then(prod => {
        this.product = prod
        console.log(this.product)
      })
    }
}

